<template>
  <div id="app" data-theme="dark">
    <router-view/>
  </div>
</template>

<script>
import i18n from './lang'

export default {
  methods:{
    invokeChildRef:()=>{
      i18n.locale = i18n.locale == 'en'?'zh':'en';
    },
  },
  mounted(){
    console.log("====vue mounted successful.====");
    const style = localStorage.getItem('easyScssStyle') || this.$seting.themeName;
    Object.keys(this.$scss[style]).reduce((acc, item) => {
      document.getElementsByTagName('body')[0].style.setProperty(item, this.$scss[style][item]);
    }, []);
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #c7edcc;
  height: 100vh; /*100%充满屏幕*/
}
</style>
